import { typography } from '@dentalux/ui-library-core'
import { createUseStyles } from 'react-jss'
import { forPhoneOnly } from 'src/config/mediaQueries'
import { Theme } from '@mui/material/styles'

export default createUseStyles((theme: Theme) => ({
  clinicInfo: {
    padding: [16, 0, 24],
    borderTop: `1px solid ${theme.palette.grey[300]}`,
    [forPhoneOnly]: {
      margin: [0, 16],
    },
  },
  clinicName: {
    ...typography['Lato H5 Bold'],
    marginBottom: 8,
  },
  addresLine: {
    display: 'flex',
    alignItems: 'center',
  },
  clinicAddress: {
    ...typography['Lato Body 2'],
  },
  distanceContainer: {
    marginLeft: 8,
    display: 'flex',
    alignItems: 'center',
  },
  distance: {
    marginLeft: 4,
    ...typography['Lato Caption Bold'],
  },
}))
